import React, { ChangeEvent, KeyboardEvent } from 'react';
import { Button } from '../../ui';
import './MessageInput.scss';

export interface MessageInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  disabled?: boolean;
  placeholder?: string;
}

const MessageInput: React.FC<MessageInputProps> = ({
  value,
  onChange,
  onSend,
  disabled = false,
  placeholder = 'Type your message...',
}) => {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  const handleSend = () => {
    if (value.trim() && !disabled) {
      onSend();
    }
  };

  return (
    <div className="message-input">
      <textarea
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="message-input__textarea"
        disabled={disabled}
        rows={3}
      />
      <Button
        onClick={handleSend}
        disabled={disabled || !value.trim()}
        className="message-input__send-button"
        size="medium">
        Send
      </Button>
    </div>
  );
};

export default MessageInput;
